export default {
  common: {
    totalPrefix: "Total ",
    totalSuffix: " items",
    download: "Download",
    loading: "Loading...",
    empty: "No Data",
    downloadFilename: "Details",
  },
  columns: {
    action: "Action",
    client: "Client",
    state: "Status",
    updateTime: "Updated Time",
    paymentMethod: "Payment Method",
    paymentDetail: "Payment Detail",
    bankCard: "Bank Card/Account",
    bankBranch: "Bank Branch",
    bankName: "Bank Name",
  },
};
